import {
  Button,
  FormControl,
  InputLabel,
  makeStyles,
  Select,
  TextField,
} from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { useInstitutions } from '../institutions/Institutions';

const useStyles = makeStyles((theme) => ({
  input: {
    marginTop: '20px',
    width: '50%',
  },
}));

function useForm() {
  const [entries, setEntries] = useState({});
  const { id } = useParams();

  useEffect(() => {
    fetch(`https://api.edicionesmilenio.com/api/coordinators/${id}`)
      .then((response) => response.json())
      .then((data) => {
        setEntries({ ...data?.data, ...data?.data?.details });
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const handleChange = (e) => {
    setEntries({
      ...entries,
      [e.target.name]: e.target.value,
    });
  };

  return {
    entries,
    handleChange,
  };
}

export function UpdateCoordinator(props) {
  const classes = useStyles();
  const { entries, handleChange } = useForm();
  const { institutions } = useInstitutions();
  const navigate = useNavigate();

  const handleUpdate = async () => {
    try {
      const { _id, ...data } = entries;
      let response = await fetch(
        `https://api.edicionesmilenio.com/api/coordinators/${_id}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        }
      );
      let result = await response.json();
      if (result.success === true) {
        navigate('/admin/coordinators', { replace: true });
      } else {
        console.error(result.message);
        window.alert('Error al actualizar el coordinador, intente de nuevo');
      }
    } catch (err) {
      console.error(err);
      window.alert('Error al actualizar el coordinador, intente de nuevo');
    }
  };

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <TextField
        className={classes.input}
        id="email"
        label="Correo electrónico"
        type="email"
        variant="outlined"
        name="email"
        onChange={handleChange}
        value={entries?.email || ''}
      />
      <TextField
        className={classes.input}
        id="password"
        label="Contraseña"
        type="password"
        variant="outlined"
        name="password"
        onChange={handleChange}
        value={entries?.password || ''}
      />
      <TextField
        className={classes.input}
        id="name"
        label="Nombre"
        type="text"
        variant="outlined"
        name="name"
        onChange={handleChange}
        value={entries?.name || ''}
      />
      <TextField
        className={classes.input}
        id="lastName"
        label="Apellido"
        type="text"
        variant="outlined"
        name="lastName"
        onChange={handleChange}
        value={entries?.lastName || ''}
      />
      <FormControl variant="outlined" className={classes.input}>
        <InputLabel id="institution">Institución</InputLabel>
        <Select
          labelId="institution"
          id="institution"
          name="institution"
          value={entries?.institution?._id || entries?.institution || ''}
          onChange={handleChange}
          label="Institución"
          native
        >
          {institutions.map((institution) => (
            <option value={institution?._id}>{institution?.name}</option>
          ))}
        </Select>
      </FormControl>
      <TextField
        className={classes.input}
        id="phone"
        label="Teléfono"
        type="text"
        variant="outlined"
        name="phone"
        onChange={handleChange}
        value={entries?.phone || ''}
      />
      <Button
        variant="contained"
        color="primary"
        className={classes.input}
        disabled={
          // !entries.email ||
          // !entries.password ||
          !entries?.name ||
          !entries?.lastName ||
          !entries?.institution ||
          !entries?.phone
        }
        onClick={handleUpdate}
      >
        Actualizar coordinador
      </Button>
    </div>
  );
}
